import { takeEvery } from 'redux-saga/effects';

import * as actionTypes from 'store/modules/myCars';
import { loadPage } from './utils';

export default function* listenLoadPage() {
  yield takeEvery(actionTypes.loadPage.toString(), loadPage);
}
